import { Table } from "@xola/ui-kit";
import React from "react";
import { AdjustmentOperation, AdjustmentType, DemographicPrice, PartnerDemographicPrice } from "types";
import { Currency } from "../../Common/Currency";

interface DemographicTermModalProps {
    partnerDemographicPrices: PartnerDemographicPrice[];
}

export const DemographicTermTable = ({ partnerDemographicPrices }: DemographicTermModalProps) => {
    return (
        <div className="mb-8">
            <Table>
                <Table.Head>
                    <Table.Row>
                        <Table.Header>Name</Table.Header>
                        <Table.Header>Adjustment</Table.Header>
                        <Table.Header>Commission</Table.Header>
                    </Table.Row>
                </Table.Head>

                <Table.Body>
                    {partnerDemographicPrices?.map((agentDemographicPrice: PartnerDemographicPrice) => {
                        return (
                            <DemographicItem
                                key={agentDemographicPrice.template.id}
                                agentDemographicPrice={agentDemographicPrice}
                            />
                        );
                    })}
                </Table.Body>
            </Table>
        </div>
    );
};

interface DemographicItemProps {
    agentDemographicPrice: PartnerDemographicPrice;
}

export const DemographicItem = ({ agentDemographicPrice }: DemographicItemProps) => {
    const discountPrice = agentDemographicPrice.discount;
    const commissionPrice = agentDemographicPrice.commission;
    const demographicName = commissionPrice.catalogItem?.name;

    return (
        <Table.Row key={agentDemographicPrice.template.id} className="justify-between border-b border-gray-lighter">
            <Table.Cell className="w-[40%]  ">
                <div className="min-w-0 whitespace-normal">{demographicName}</div>
            </Table.Cell>

            <Table.Cell className="w-[30%]">
                {getDiscountPriceSymbol(discountPrice)}
                <TermValue termAlgorithm={discountPrice.adjustmentType} termValue={discountPrice.adjustmentAmount} />
                {discountPrice.adjustmentOperation === AdjustmentOperation.FINAL && " (Final price)"}
            </Table.Cell>

            <Table.Cell className="w-[30%]">
                <TermValue
                    termAlgorithm={commissionPrice.adjustmentType}
                    termValue={commissionPrice.adjustmentAmount}
                />
            </Table.Cell>
        </Table.Row>
    );
};

interface TermValueProps {
    termAlgorithm?: AdjustmentType;
    termValue?: number;
}

export const TermValue = ({ termAlgorithm, termValue }: TermValueProps) => {
    return termAlgorithm === AdjustmentType.ABSOLUTE ? <Currency>{termValue}</Currency> : <>{termValue}%</>;
};

export const getDiscountPriceSymbol = (discountPrice: DemographicPrice): string => {
    const adjustmentOperation = discountPrice.adjustmentOperation ?? AdjustmentOperation.FINAL;

    if ([AdjustmentOperation.MARKDOWN, AdjustmentOperation.DISCOUNT].includes(adjustmentOperation)) {
        return "-";
    }

    if (adjustmentOperation === AdjustmentOperation.MARKUP) {
        return "+";
    }

    return "";
};
